module.exports = __webpack_public_path__ + "h5/img/canvass1.e599e164.jpg";